export default class CustomWrapperControl {
  constructor(items) {
    this.items = items;
  }

  /**
   * Function which is used to fix the position where the controller will be placed on map
   */
  // eslint-disable-next-line class-methods-use-this
  getDefaultPosition() {
    const defaultPosition = "bottom-right";
    return defaultPosition;
  }

  /**
   * Function which is used to add custom control on map
   * @param {*} map Instance of map which is passed
   */
  onAdd(map) {
    this.map = map;
    this.container = document.createElement("div");

    this.items.forEach((element) => {
      const eleHtml = element.onAdd(map);
      this.container.appendChild(eleHtml);
    });

    this.mainContainer = document.createElement("div");
    // For placing the elements row-wise
    this.container.style.display = "flex";
    this.container.style.flexFlow = "row-reverse";
    this.mainContainer.classList.add("mapboxgl-ctrl");
    // For hiding the borders
    this.mainContainer.classList.add("transparent-background");
    this.mainContainer.appendChild(this.container);
    return this.mainContainer;
  }

  /**
   * Function which is used to remove custom control from the map
   */
  onRemove() {
    this.mainContainer.parentNode.removeChild(this.mainContainer);
    this.map = undefined;
  }
}
